import React, { useMemo, useState } from "react";
import { Autocomplete, Button, TextField } from "@mui/material";
import { extractAllowedUserRoleList } from "../../../../Utils/Utils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { setDataWithKeyboardValueCheck } from "../../helpers";

type IProps = {
  filter: any;
  initialFilters: any;
  onFilter: (filter: any) => void;
};

const EmployeeBioDataFilter: React.FC<IProps> = ({ filter, onFilter, initialFilters }) => {
  const onChangeFilter = (name: string, value: string) => {
    setPrivateFilter((filter: any) => ({
      ...filter,
      [name]: value,
    }));
  };

  const [privateFilter, setPrivateFilter] = useState(filter);

  const allowedRoleIdList = useMemo(() => {
    let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies") || "{}");
    let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
    return allowedRoleIdList.filter(({ value }) => value !== "admin");
  }, []);

  return (
    <div className="filters-container">
      <TextField
        className="filter-input"
        type="text"
        size="small"
        label="Name"
        name="name"
        value={privateFilter?.name || ""}
        onChange={(e) => onChangeFilter(e.target.name, e.target.value)}
      />

      <TextField
        className="filter-input"
        type="text"
        size="small"
        label="Email"
        name="email"
        value={privateFilter?.email || ""}
        onChange={(e) => onChangeFilter(e.target.name, e.target.value)}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        disableCloseOnSelect
        options={allowedRoleIdList}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Designation" placeholder="Designation" />
        )}
        getOptionLabel={(customer) => {
          return customer.value;
        }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={allowedRoleIdList.find((option) => option.value === privateFilter?.designation) || null}
        onChange={(_, newValue) => {
          onChangeFilter("designation", newValue?.value || null);
        }}
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Refresher Done From"
          renderInput={(params) => <TextField {...params} size="small" />}
          onChange={(value: any, keyboardInputValue?: string) => {
            const keyName = "refresherDoneFrom";

            setDataWithKeyboardValueCheck({
              keyName,
              onChangeFilter,
              value,
              keyboardInputValue,
            });
          }}
          value={privateFilter?.refresherDoneFrom || null}
        />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="PME Done From"
          renderInput={(params) => <TextField {...params} size="small" />}
          onChange={(value: any, keyboardInputValue?: string) => {
            const keyName = "pmeDoneFrom";

            setDataWithKeyboardValueCheck({
              keyName,
              onChangeFilter,
              value,
              keyboardInputValue,
            });
          }}
          value={privateFilter?.pmeDoneFrom || null}
        />
      </LocalizationProvider>

      <Button variant="contained" onClick={() => onFilter(privateFilter)}>
        Filter
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          onFilter(initialFilters);
          setPrivateFilter(initialFilters);
        }}
      >
        Clear
      </Button>
    </div>
  );
};

export default EmployeeBioDataFilter;
